import CrudPage from "@/components/admin/CrudPage";

const FIELDS = [
  { key: "name", label: "Name" },
  { key: "price_range", label: "Price range" },
  { key: "description", label: "Description", type: "textarea", rows: 2, span: "full" },
  { key: "quote_required", label: "Quote required", type: "checkbox" },
  { key: "active", label: "Active", type: "checkbox" },
  { key: "sort_order", label: "Sort order", type: "number" },
];

const BLANK = {
  name: "", price_range: "", description: "", quote_required: false,
  active: true, sort_order: 99,
};

export default function AdminAddOns() {
  return (
    <CrudPage
      resource="addons"
      title="Add-Ons"
      description="Add-on prices update on the public Pricing page automatically after saving."
      fields={FIELDS}
      blank={BLANK}
      testIdPrefix="addons"
    />
  );
}
